import MessagesFooter from "./MessagesFooter";
export default MessagesFooter;